import { render, staticRenderFns } from "./OProductList.vue?vue&type=template&id=055df014&"
import script from "./OProductList.vue?vue&type=script&lang=js&"
export * from "./OProductList.vue?vue&type=script&lang=js&"
import style0 from "./OProductList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports